<template>
  <Modal appear variant="tutorial" @close="close" v-if="isOpenModal">
    <template slot="content">
      <div class="p-contentplans-tutorial">
        <transition name="v-fade" mode="out-in">
          <div class="p-contentplans-tutorial-slider">
            <div class="p-contentplans-tutorial-slider__prev">
              <button @click="slidePrev" :disabled="isDisabledPrev">
                <Icon2
                  variant="arrow_l"
                  size="40"
                  :color="isDisabledPrev ? 'lgy' : 'gy'"
                />
              </button>
            </div>
            <div class="p-contentplans-tutorial-slider-section">
              <div class="p-contentplans-tutorial-slider-nav">
                <div
                  v-for="index in slider.total"
                  :key="index"
                  class="p-contentplans-tutorial-slider-nav__item"
                  :class="{ 'is-active': slider.current === index - 1 }"
                >
                  {{ index }}
                </div>
              </div>
              <transition name="v-fade" mode="out-in">
                <div
                  v-if="slider.current === 0"
                  key="0"
                  class="p-contentplans-tutorial-slider__item"
                >
                  <div class="p-contentplans-tutorial-slider__text">
                    <p>
                      まずは<strong
                        >「コンテンツ調査」で、どのような記事を作成するのか大まかに把握しましょう。</strong
                      >
                    </p>
                  </div>
                  <div class="p-contentplans-tutorial-slider__img">
                    <img
                      src="@/assets/img/content-plans/img-tutorial01.png"
                      alt=""
                      width="444"
                      height="324"
                    />
                  </div>
                </div>
                <div
                  v-else-if="slider.current === 1"
                  key="1"
                  class="p-contentplans-tutorial-slider__item"
                >
                  <div class="p-contentplans-tutorial-slider__text">
                    <p>
                      次に<strong
                        >「タイトル・見出し設計」でチャットAIと一緒に骨子を作成しましょう。</strong
                      ><br />提供された情報を参考に、ユーザーのニーズを満たす記事構成案を作成してください。
                    </p>
                  </div>
                  <div class="p-contentplans-tutorial-slider__img">
                    <img
                      src="@/assets/img/content-plans/img-tutorial02.png"
                      alt=""
                      width="622"
                      height="344"
                    />
                  </div>
                </div>
                <div
                  v-else-if="slider.current === 2"
                  key="2"
                  class="p-contentplans-tutorial-slider__item"
                >
                  <div class="p-contentplans-tutorial-slider__text">
                    <p>
                      <strong
                        >作成した記事構成案はテキストファイルでダウンロードできます。</strong
                      ><br />記事作成マニュアルと併せて、本文の執筆や校正に活用してください。
                    </p>
                  </div>
                  <div class="p-contentplans-tutorial-slider__img">
                    <img
                      src="@/assets/img/content-plans/img-tutorial03.png"
                      alt=""
                      width="500"
                      height="250"
                    />
                  </div>
                </div>
                <div
                  v-else-if="slider.current === 3"
                  key="3"
                  class="p-contentplans-tutorial-slider__item"
                >
                  <div class="p-contentplans-tutorial-slider__text">
                    <p>
                      リライトを行う際は、上位ページの内容や記事作成マニュアルを参考に改善を行ってください。
                    </p>
                    <p class="c-text--comment">
                      ※リライト専用のチャットAI機能も順次リリース予定です
                    </p>
                  </div>
                  <div class="p-contentplans-tutorial-slider__img">
                    <img
                      src="@/assets/img/content-plans/img-tutorial04.png"
                      alt=""
                      width="500"
                      height="214"
                    />
                  </div>
                  <Button
                    variant="main"
                    size="w230"
                    @click="close"
                    class="p-contentplans-tutorial-slider__button"
                    >さっそく使ってみる</Button
                  >
                </div>
              </transition>
            </div>
            <div class="p-contentplans-tutorial-slider__next">
              <button @click="slideNext" :disabled="isDisabledNext">
                <Icon2
                  variant="arrow_r"
                  size="40"
                  :color="isDisabledNext ? 'lgy' : 'gy'"
                />
              </button>
            </div>
          </div>
        </transition>
      </div>
    </template>
  </Modal>
</template>

<script>
import Button from '@/components/Button';
import Icon2 from '@/components/Icon2';
import Modal from '@/components/Modal';
export default {
  components: {
    Button,
    Icon2,
    Modal
  },
  data() {
    return {
      slider: {
        current: 0,
        total: 4
      },
      isOpenModal: false
    };
  },
  computed: {
    isDisabledPrev() {
      return this.slider.current <= 0;
    },
    isDisabledNext() {
      return this.slider.current >= this.slider.total - 1;
    }
  },
  created() {
    this.getIsOpenedModal();
  },
  methods: {
    close() {
      this.isOpenModal = false;
      this.setIsOpenedModal();
    },
    getIsOpenedModal() {
      // Note: デモ環境の場合は必ず開く（後で変更するかも）
      if (this.$constants.isDemo) {
        this.isOpenModal = true;
        return;
      }
      this.auth
        .getUserData()
        .then(response => {
          const metaData = response.data.user_metadata;
          if (
            metaData.contentPlans &&
            metaData.contentPlans.isOpenedTutorialModal
          ) {
            this.isOpenModal = false;
          } else {
            this.isOpenModal = true;
          }
        })
        .catch(() => {
          // エラーの場合は必ず開く
          this.isOpenModal = true;
        });
    },
    setIsOpenedModal() {
      if (this.$constants.isDemo) {
        return;
      }
      this.auth
        .getUserData()
        .then(response => {
          const metaData = response.data.user_metadata;
          metaData.contentPlans = {
            isOpenedTutorialModal: true
          };
          const data = {
            user_metadata: metaData
          };

          this.auth.updateUserData(data);
        })
        .catch(() => {
          // Note: 更新失敗しても大きな問題にはならないため、エラーハンドリングをしないという判断
        });
    },
    slideNext() {
      if (this.slider.current >= this.slider.total - 1) {
        return;
      }
      this.slider.current++;
    },
    slidePrev() {
      if (this.slider.current <= 0) {
        return;
      }
      this.slider.current--;
    }
  }
};
</script>
